module.exports = __webpack_public_path__ + "img/bussiness-item-4.79137e66.png";